import { DeploySystemDetail } from '@/app/interfaces/deploy-system-of-ai-detail';
import { SystemDeployReviewFieldKey } from '@/app/interfaces/system-deploy-review-fields.types';
import { SystemDeployReviewFieldsService } from '@/app/services/ia-services/system-deploy-review-fields.service';
import { TooltipComponent } from '@/app/shared/tooltip/tooltip.component';
import { mapRiskLevelLabel } from '@/app/shared/mappers/risk-level-label.mapper';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-system-deploy-risk-management',
  standalone: true,
  imports: [CommonModule, TooltipComponent],
  templateUrl: './risk-management.component.html',
})
export class SystemDeployRiskManagementComponent {
  @Input() riskData: DeploySystemDetail | null = null;
  @Input() reviewMode = false;
  @Input() readonlyReview = false;
  @Input() showPreviousReviewIndicators = false;

  constructor(public reviewFields: SystemDeployReviewFieldsService) {}

  previousReviewText(fieldKey: SystemDeployReviewFieldKey): string {
    return this.reviewFields.getPreviousReviewTooltipText(fieldKey);
  }

  riskLevelLabel(value: string | null | undefined): string {
    return mapRiskLevelLabel(value);
  }
}
